import { Box, Grid, List, ListItem, MenuList, Typography } from '@mui/material'
import React from 'react'
// import wolfpack from '../../Assets/Images/CaseStudies/'
import wefroth from '../../Assets/Images/CaseStudies/Wefroth.png'
import wefrothCaseStudy from '../../Assets/Images/CaseStudies/WefrothCaseStudy.jpeg'
import img2 from '../../Assets/Images/CaseStudies/CaseStudy2.jpg'
import { useAppContext } from '../../context/useAppContext';

function WefrothCaseStudies() {
  const { darkTheme } = useAppContext();

  const features = [
    "Court and event booking",
    "Team and player management",
    "⁠League and competition management",
    "Live scores and commentary",
    "⁠Attendance management and automated fines",
    "Online and POS payments",
    "Payroll and automated pay runs",
    "⁠Bank-ready payment files",
    "Advanced roster management",
    "⁠Daily operational run sheets",
    "AI-powered match reviews",
  ];
  const Challenges = [
    "Fragmented Booking & Venue Management",
    "Complex Team & Competition Management",
    "⁠League and competition management",
    "Manual Rostering & Daily Operations",
    "Payroll & Attendance Challenges",
    "Disconnected Payment Processes",
    "Limited Real-Time Match Visibility",
    "Growing Operational Complexity",
    "Need for a Better User Experience",
  ];

  const features2 = [
    "70% reduction in administrative hours",
    "⁠Streamlined and accurate payroll processing",
    "Smoother daily operations",
    "Improved workforce coordination",
    "More efficient competition management",
    "Real-time match experiences",
    "A scalable sports management ecosystem",
  ];


  return (
    <Box mt={{ xs: 8, md: 4, lg: 5 }}>
      <Typography
        component="h1"
        variant="h1"
        sx={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0
        }}
      >
        CASE STUDY
      </Typography>
      <Grid container alignItems={'start'}>
        <Grid size={{ xs: 12, md: 5 }}>
          <Typography className='text-light-main fs-24 fw-bold mb-3'>CASE STUDY</Typography>
          <Typography className='text-color-main fs-36 fw-bold mb-3'>How App Gallery Helped WeFroth Build the Future of Connected Sports Management</Typography>
          <Typography className='fs-16 text-grey'>A long-term technology partnership that transformed a complex sports vision into a scalable platform for bookings, teams, competitions, operations, payments and live matches.</Typography>
          <Box className='mt-3'>
            <svg width="283" height="51" viewBox="0 0 283 51" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1602_1368)">
                <path d="M127.474 7.27015C132.133 7.18883 136.888 7.26695 141.55 7.24813C144.764 7.23516 149.961 6.955 152.895 8.0121C155.298 8.89784 157.253 10.7003 158.335 13.0263C159.697 15.9385 159.657 20.5018 157.665 23.1393C156.247 25.0163 154.868 25.9187 152.802 26.8857C153.731 28.4089 154.92 30.8439 155.798 32.5155C157.059 34.9178 159.194 38.4913 160.133 40.9587C158.304 40.8594 155.49 40.9397 153.591 40.9411C151.782 40.9551 149.973 40.9492 148.165 40.9236C147.533 39.9845 146.646 38.1014 146.113 37.0193C144.758 34.2145 143.419 31.4023 142.094 28.5827C140.809 28.5668 139.474 28.5991 138.185 28.6147C138.056 32.6792 138.284 36.9708 138.086 40.9666C135.752 40.7897 129.713 40.9028 127.284 40.9928C127.199 38.3179 127.266 35.232 127.264 32.5272L127.258 16.2612C127.257 14.8428 127.123 7.85079 127.474 7.27015ZM138.195 14.9616C138.126 16.8886 138.088 19.1829 138.148 21.1292C139.909 21.1435 144.917 21.3226 146.405 20.8781C147.171 20.3243 147.4 20.0646 148.028 19.3496C149.046 13.8212 143.35 14.8036 139.708 14.895L138.195 14.9616Z" fill={darkTheme ? "white" : "black"} />
                <path d="M59.3203 11.0024C64.0033 6.66755 72.3093 2.64898 78.8007 3.02885C83.6323 3.31158 86.7174 5.08124 89.9543 8.55058C92.2145 10.9732 93.0684 12.9362 94.6378 15.6481C94.4537 14.3871 94.4735 8.64431 94.5792 7.27861C103.578 7.18467 112.96 7.45669 121.886 7.22902L121.899 15.3457C116.875 15.3107 110.387 15.1319 105.463 15.378C105.59 16.8419 105.456 19.4952 105.454 21.0691L119.531 21.0656C119.536 23.6216 119.571 26.2503 119.534 28.8C114.957 28.8034 110.01 28.7167 105.463 28.8333C105.556 30.0774 105.48 32.855 105.461 34.2526C105.437 36.081 105.594 39.2607 105.429 40.9658C102.6 40.8557 97.4138 40.8455 94.5926 40.9908C94.4573 38.7906 94.5147 36.2313 94.5145 34.0031C87.7019 42.4079 71.2852 49.8643 61.774 41.8384C58.6824 39.2297 56.0047 35.2865 54.4924 31.5508C54.2979 33.1664 53.5099 36.1963 53.1096 37.8758C52.5143 40.3743 51.9013 43.8859 51.1506 46.2685L36.0658 46.3002C34.8066 41.0931 33.7833 35.6195 32.6142 30.3754C31.8817 27.0895 31.3287 23.2671 30.4023 20.0537C29.4957 24.4941 28.4701 28.9346 27.5915 33.3716C27.0392 36.2495 26.4423 39.1187 25.8009 41.978C25.5282 43.2312 25.1761 45.0945 24.8225 46.2867L9.7706 46.299C8.64915 41.9729 7.79871 37.8657 6.79304 33.5588L2.58206 15.8808C1.73259 12.2539 1.01562 8.59065 0.122466 4.97185C0.0843725 4.81751 0.0508008 4.67594 0 4.52452V3.6271L14.0125 3.62956C15.773 11.807 17.423 20.0079 18.9624 28.2302C20.7597 21.6095 21.6542 14.168 23.1471 7.44352C23.4252 6.19068 23.6324 4.85331 23.9912 3.6255C27.8169 3.63065 33.875 3.82703 37.5077 3.57935C38.8633 11.5382 41.2337 20.0479 42.7195 28.1005L45.9061 11.6141C46.3273 9.43931 46.9341 5.72424 47.5206 3.65409C51.9997 3.60838 56.7426 3.73208 61.1719 3.60309C60.5855 6.02017 59.9733 8.61137 59.3203 11.0024ZM69.8739 29.9175C70.4228 30.8642 71.4502 32.5 72.3804 33.1033C73.2162 33.7857 73.9957 34.2918 75.0873 34.5223C78.7815 35.3024 85.0796 31.825 84.6232 27.5288C84.5489 26.8291 84.2385 25.833 84.0282 25.1533C85.9231 23.9581 88.345 22.7524 90.3447 21.6365C91.4565 21.0162 93.4739 19.8178 94.5134 19.3426C94.5158 18.8266 94.5988 16.6652 94.3922 16.3757C88.296 19.9528 81.5915 23.2527 75.4802 26.855C73.7797 27.8574 71.4567 28.9106 69.8739 29.9175ZM66.5952 23.841C67.2798 23.4723 69.3389 22.2417 69.9458 22.0514C72.6905 20.4999 75.4213 18.93 78.2194 17.4769C78.4112 17.3773 78.6032 17.2742 78.7783 17.1467C77.5467 15.1248 75.8566 13.3705 73.2601 13.6218C67.9027 14.5673 64.7585 18.424 66.5952 23.841Z" fill={darkTheme ? "white" : "black"} />
                <path d="M211.956 7.27532C215.242 7.18208 218.895 7.2569 222.219 7.25724L244.682 7.2345C244.863 9.42588 244.734 13.5856 244.722 15.8734C241.2 15.8563 237.282 15.7737 233.791 15.9166C233.906 20.3721 233.74 25.7441 233.74 30.2808C233.729 33.3323 233.919 38.0308 233.714 40.9323C230.258 40.9238 226.32 40.8516 222.898 40.9955C222.512 32.9451 223.11 24.0642 222.77 15.8885C219.141 15.7758 215.431 15.9287 211.786 15.8544C211.695 14.5992 211.534 8.02682 211.956 7.27532Z" fill={darkTheme ? "white" : "black"} />
                <path d="M184.933 0H189.433C191.156 0.419336 192.837 0.537766 194.579 1.09041C219.456 8.97809 218.394 44.0526 193.011 50.3125C191.977 50.5672 190.637 50.7067 189.647 51H184.633C183.891 50.7573 182.256 50.5062 181.399 50.3017C178.934 49.7128 176.249 48.714 174.082 47.4077C168.258 43.9134 164.065 38.2324 162.435 31.6255C160.843 25.1883 161.846 18.0127 165.265 12.3299C168.566 6.80889 173.852 2.76559 180.033 1.03061C181.818 0.514206 183.232 0.420891 184.933 0ZM180.718 40.038C184.969 37.2976 189.151 34.4526 193.261 31.5058C195.679 29.9549 199.156 27.5278 201.534 25.8602C197.185 22.793 192.797 19.7831 188.371 16.8317C185.829 15.1111 183.361 13.2506 180.732 11.6819C180.88 19.9392 180.638 28.2582 180.747 36.5222C180.762 37.6692 180.748 38.891 180.718 40.038Z" fill={darkTheme ? "white" : "#3581b8"} />
                <path d="M283 7.27612V40.93C279.562 40.9305 275.773 40.8565 272.363 40.9976C272.255 36.7887 272.361 32.338 272.314 28.096L260.574 28.1155C260.446 30.9087 260.533 33.7864 260.524 36.5837C260.519 37.9897 260.607 39.5859 260.477 40.9721C258.156 40.7699 252.182 40.9265 249.695 40.9636C249.562 37.2517 249.662 32.9189 249.662 29.1654L249.665 7.27846C252.899 7.1311 257.193 7.25916 260.516 7.23023C260.804 10.7952 260.285 15.5234 260.602 19.4627C264.007 19.5927 268.94 19.5977 272.331 19.4536C272.387 15.4092 272.303 11.3479 272.374 7.28566C275.556 7.15744 279.798 7.22813 283 7.27612Z" fill={darkTheme ? "white" : "black"} />
              </g>
              <defs>
                <clipPath id="clip0_1602_1368">
                  <rect width="283" height="51" fill={darkTheme ? "white" : "black"} />
                </clipPath>
              </defs>
            </svg>

          </Box>
        </Grid>
        <Grid position={'relative'} size={{ xs: 11, md: 7 }} className='d-flex justify-content-end'>
          <Box component={'img'} src={wefroth} alt='mysterymanagement' height={{ xs: "300px", md: '500px' }}></Box>
          <Box className='d-flex align-items-center justify-content-center p-3' position={'absolute'} top={'70%'} right={'0%'} bgcolor={darkTheme ? '#000000' : "#FFFFFF"} height={'200px'} width={'200px'} borderRadius={"50%"}>
            <Box className='border-main h-100 w-100 overflow-hidden d-flex flex-column align-items-center justify-content-center p-3' borderRadius={'50%'}>
              <Typography className='text-light-main text-center fw-bold' variant='h4'>70%</Typography>
              <Typography className=' fs-14 mb-1 text-color-main text-center'>REDUCTION IN</Typography>
              <Typography className=' fs-14 mb-1 text-color-main text-center'>ADMINISTRATIVE HOURS</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container className='mt-5' spacing={5}>
        <Grid size={{ xs: 12, md: 4 }} alignItems={'center'} className='border-10 overflow-hidden'>
          <Box component={'img'} src={wefrothCaseStudy} height={'100%'} minHeight={'300px'} width={'100%'} className='bordre-10 overflow-hidden'></Box>
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <Box>
            <Typography className='fs-32 text-light-main mb-2'>About the client</Typography>
            <Typography className='fs-16 text-color-main mb-2'>
              WeFroth is a next-generation sports management platform that brings players, teams, venues and fans together through one connected digital ecosystem.
            </Typography>
            <Typography className='fs-16 text-color-main mb-2'>The platform simplifies court bookings, team management, competitions, live matches, workforce operations and payments.</Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container className='mt-4 bg-light-main border-10 p-4'>
        <Grid size={{ xs: 12, md: 'grow' }}>
          <Box className='d-flex align-items-center gap-4 mb-4'>
            <Box className='border-main p-1 border-50'>
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-locate-fixed-icon lucide-locate-fixed"><line x1="2" x2="5" y1="12" y2="12" /><line x1="19" x2="22" y1="12" y2="12" /><line x1="12" x2="12" y1="2" y2="5" /><line x1="12" x2="12" y1="19" y2="22" /><circle cx="12" cy="12" r="7" /><circle cx="12" cy="12" r="3" /></svg>
            </Box>
            <Typography className='text-light-main fw-medium fs-32'>The Challenge</Typography>
          </Box>
          <Typography className='text-color-main mb-3 fs-16'>
            WeFroth needed to bring court bookings, teams, competitions, attendance, payments and live match updates together in one connected platform while supporting the complex day-to-day operations of sports venues.
          </Typography>
          <Typography className='text-color-main mb-3 fs-16'>
            As the platform grew, managing these activities across disconnected processes became increasingly time-consuming and difficult to scale.          </Typography>
          {Challenges.map((feature, index) => (
            <Box key={index} className="d-flex align-items-center gap-3 mb-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--primary-color)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-circle-check-big"
              >
                <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                <path d="m9 11 3 3L22 4" />
              </svg>

              <Typography className="text-color-main fs-16">
                {feature}
              </Typography>
            </Box>
          ))}
        </Grid>
        <Grid size={{ xs: 12, md: 'auto' }} my={{ xs: 2, md: 0 }}>
          <hr className='border-grey h-100 my-0 mx-0  mx-md-5 p-0' />
        </Grid>
        <Grid size={{ xs: 12, md: 'grow' }}>
          <Box className='d-flex align-items-center gap-4 mb-4'>
            <Box className='border-main p-2 border-50'>
              <svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb-icon lucide-lightbulb"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" /><path d="M9 18h6" /><path d="M10 22h4" /></svg>            </Box>
            <Typography className='text-light-main fw-medium fs-32'>The Solution</Typography>
          </Box>
          <Typography className='text-color-main mb-3 fs-16'>
            App Gallery partnered with WeFroth to design and develop a comprehensive sports management platform tailored to its operational requirements.
          </Typography>
          <Typography className='text-color-main mb-3 fs-16'>
            The platform includes:
          </Typography>
          <List className='text-color-main my-4 fs-16'>
            {features.map((feature, index) => (
              <Box key={index} className="d-flex align-items-center gap-3 mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--primary-color)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-circle-check-big"
                >
                  <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                  <path d="m9 11 3 3L22 4" />
                </svg>

                <Typography className="text-color-main fs-16">
                  {feature}
                </Typography>
              </Box>
            ))}
          </List>
        </Grid>
        <Grid size={{ xs: 12, md: 'auto' }} my={{ xs: 2, md: 0 }}>
          <hr className='border-grey h-100 my-0 mx-0 mx-md-5 p-0' />
        </Grid>
        <Grid size={{ xs: 12, md: 'grow' }}>
          <Box className='d-flex align-items-center gap-4 mb-4'>
            <Box className='border-main p-3 border-50'>
              <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trophy-icon lucide-trophy"><path d="M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978" /><path d="M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978" /><path d="M18 9h1.5a1 1 0 0 0 0-5H18" /><path d="M4 22h16" /><path d="M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z" /><path d="M6 9H4.5a1 1 0 0 1 0-5H6" /></svg>            </Box>
            <Typography className='text-light-main fw-medium fs-32'>The Results</Typography>
          </Box>
          <Typography className='text-color-main mb-3 fs-16'>
            The partnership delivered significant operational improvements and measurable outcomes:
          </Typography>
          <List className='text-color-main my-4 fs-16'>
            {features2.map((feature, index) => (
              <Box key={index} className="d-flex align-items-center gap-3 mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--primary-color)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-circle-check-big"
                >
                  <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                  <path d="m9 11 3 3L22 4" />
                </svg>

                <Typography className="text-color-main fs-16">
                  {feature}
                </Typography>
              </Box>
            ))}
          </List>
        </Grid>
        <Grid size={12} className='p-4 mt-4 border-10' bgcolor={darkTheme ? "rgba(54, 54, 54, 0.9)" : "rgba(255, 255, 255, 0.4)"}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 'grow' }}>
              <Box className='d-flex align-items-center gap-3'>
                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-no-axes-combined-icon lucide-chart-no-axes-combined"><path d="M12 16v5" /><path d="M16 14.639V21" /><path d="M20 10.656V21" /><path d="m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15" /><path d="M4 18.463V21" /><path d="M8 14.656V21" /></svg>
                <Box>
                  <Typography className='text-light-main fs-42 fw-medium'>70%</Typography>
                  <Typography className='text-color-main fs-24 fw-medium'>LESS ADMINISTRATION</Typography>
                  <Typography className='text-grey fs-16'>Through intelligent workflow automation.</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 'auto' }}>
              <hr className='border-grey h-100 m-0 p-0' />
            </Grid>
            <Grid size={{ xs: 12, md: 'grow' }}>
              <Box className='d-flex align-items-center gap-3'>
                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings-icon lucide-settings"><path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" /><circle cx="12" cy="12" r="3" /></svg>                                    <Box>
                  <Typography className='text-light-main fs-32 fw-medium' lineHeight={'normal'}>ERROR-FREE</Typography>
                  <Typography className='text-color-main fs-24 fw-medium' lineHeight={'normal'}>AUTOMATED PAYROLL</Typography>
                  <Typography className='text-grey fs-16'>with bank-ready payment files</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 'auto' }}>
              <hr className='border-grey h-100 m-0 p-0' />
            </Grid>
            <Grid size={{ xs: 12, md: 'grow' }}>
              <Box className='d-flex align-items-center gap-3'>
                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-icon lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><path d="M16 3.128a4 4 0 0 1 0 7.744" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><circle cx="9" cy="7" r="4" /></svg>                                    <Box>
                  <Typography className='text-light-main fs-32 medium' lineHeight={'normal'}>SMOOTHER</Typography>
                  <Typography className='text-color-main fs-24 medium' lineHeight={'normal'}>DAILY OPERATIONS</Typography>
                  <Typography className='text-grey fs-16'>with rostering and run sheets.</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container className='mt-2 bg-light-main border-10 p-3 px-4' justifyContent={'space-between'}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Box>
            <Typography className='fs-32 text-light-main mb-3'>Long-Term Partnership</Typography>
            <Typography className='fs-16 text-color-main mb-3'>
              What began as a sports platform development initiative has evolved into a strategic technology partnership.
            </Typography>
            <Typography className='fs-16 text-color-main mb-3'>
              App Gallery continues to work closely with WeFroth to refine operational workflows, introduce new functionality and support the platform’s long-term growth.
            </Typography>
            <Typography className='fs-16 text-color-main mb-3'>
              Together, App Gallery and WeFroth remain focused on building technology that makes sports management simpler, smarter and more connected.
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box component={'img'} src={img2} height={'100%'} minHeight={'300px'} width={'100%'} className='ms-auto' ></Box>
        </Grid>
      </Grid>
      <Grid container spacing={3} bgcolor={'hsl(187, 100%, 12%)'} alignItems={'start'} className='mt-3 border-10 p-3'>
        <Grid size={{ xs: 12, md: 'grow' }}>
          <Typography className='text-light-main fs-32 mb-1'>Client testimonial</Typography>
          <Typography className='text-white fs-16'>"App Gallery understood our requirements and transformed them into a sports management platform tailored to how we operate.
            Their responsiveness and ability to adapt have helped streamline our operations and save us a significant amount of time.
            We are extremely happy with the outcome and would recommend App Gallery to anyone looking to build a reliable and scalable technology solution."</Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 'auto' }}>
          <Box className='d-flex align-items-center gap-3'>
            <Box component={'img'} src={'/Images/ClientTestimonial/peter.png'} height={'150px'} width={'150px'} className='border-main' sx={{ borderRadius: '50%', objectFit: 'cover' }}></Box>
            <Box>
              <Typography className='fs-28 text-white'>Peter Parthimos</Typography>
              <Typography className='fs-16 text-white'>CEO & Founder</Typography>
              <Typography className='fs-20 text-light-main'>Futsal Oz / WeFroth</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container className='mt-3 border-main border-10 p-4'>
        <Box className='d-flex flex-column flex-md-row align-items-start align-items-md-center gap-4'>
          <Box className='p-3 border-main' bgcolor={'hsl(187, 100%, 12%)'} sx={{ boxShadow: '0px 0px 10px var(--primary-color)' }} borderRadius={'50%'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-no-axes-combined-icon lucide-chart-no-axes-combined"><path d="M12 16v5" /><path d="M16 14.639V21" /><path d="M20 10.656V21" /><path d="m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15" /><path d="M4 18.463V21" /><path d="M8 14.656V21" /></svg>
          </Box>
          <Box>
            <Typography className='fs-16 text-grey'>WeFroth combines bookings, team coordination, competitions, live match experiences, workforce management, payroll, payments and AI-powered insights within one unified ecosystem.</Typography>
            <hr className='border-grey w-100 m-0 my-2 p-0' />
            <Typography className='fs-20 text-color-main'>From booking a court to managing daily operations, WeFroth makes every part of the sporting experience more connected.</Typography>
          </Box>
        </Box>
      </Grid>

    </Box>
  )
}

export default WefrothCaseStudies
